<template>
  <modal ref="modal">
    <template #title>Zugangsdaten bearbeiten
      <span class="text-uppercase">({{ channel }})</span>
    </template>
    <template #content>
      <div v-if="credentials.facebook_token">
        <facebook-login :index="index"></facebook-login>
      </div>
      <div v-else>
        Sie wurden erfolgreich abgemeldet.
      </div>
    </template>
    <template #footer>
      <button class="btn btn-secondary" @click="closeModal">Schließen</button>
    </template>
  </modal>
</template>

<script>
import FacebookLogin from "../facebook/FacebookLogin";
import Modal from "../../common/modal/Modal";

export default {
  name: 'FacebookLogoutModal',
  components: {Modal, FacebookLogin},
  props: ['channel', 'credentials'],
  methods: {
    closeModal() {
      let element = this.$refs.modal.$el
      $(element).modal('hide')
    },
  }
}
</script>

<style scoped>
</style>
